/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
"use strict"

import _ from "lodash"
import angular from "angular"

angular
  .module("uCountitUiApp")

  .factory("BrandSrv", function ($rootScope, $http, ApiSrv, $cookies) {
    let brand = null
    let cacheFaviconHtml = null
    let currentFaviconUrl = null

    const getUIBrandFromCookie = () => {
      try {
        return $cookies.get("ui_brand") || null
      } catch (e) {
        console.warn("Failed to read ui_brand cookie:", e)
        return null
      }
    }

    const defaultBrand = {
      brandName: "uCount.it",
      email: "support@ucountit.com",
      copyrightText: "",
      logo: {
        url: "/assets/images/ucountit-logo.png",
      },
      emblem: {
        url: "/assets/images/ucountit-emblem.png",
      },
      favicon: {
        url: "/assets/favicons/favicons.html",
      },
      signin: {
        showBrandName: true,
        hexColor: "#0078ab",
        url: "/assets/images/background/bg-graph.png",
      },
      colorTheme: {
        index: 1,
      },
      signinNotification: {
        active: false,
        text: "",
      },
      language: "en",
      region: "en-gb",
      terms: {
        path: "",
        forceAgree: false,
      },
      privacy: {
        path: "",
      },
      navMenu: {
        footfall: true,
        zonetraffic: true,
        occupancy: true,
        heatmap: true,
        directionmap: true,
        genderAge: true,
        flowmap: true,
        dashboardFace: false,
        "tracking-tree": true,
        "path-tree": true,
        "app.datadownload": true,
        "app.premiumReport": true,
        "app.standardReport": true,
        "admin.event": true,
        "admin.s3fileapi": true,
        "system.operation": true,
        "system.data-operation": true,
        "system.recording": true,
        "system.monitoring": true,
        v2: true,
      },
      isCustom: false,
    }

    const retailTrendBrand = _.merge({}, defaultBrand, {
      brandName: "RetailTrend",
      email: "support@retailtrend.com",
      logo: {
        url: "/assets/retailtrend/retailtrend-log180x35.png",
      },
      emblem: {
        url: "/assets/retailtrend/retailtrend-emblem150.png",
      },
      favicon: {
        url: "/assets/retailtrend/favicons/favicons.html",
      },
      signin: {
        showBrandName: false,
        hexColor: "#39267d",
        url: "/assets/images/background/bg-graph-grey.png",
      },
      colorTheme: {
        index: 25,
      },
      language: "ko",
      region: "ko-kr",
    })

    const developmentBrand = _.merge({}, defaultBrand, {
      brandName: "Development",
      email: "support@development.com",
      logo: {
        url: "/assets/development/development-logo180x35.png",
      },
      emblem: {
        url: "/assets/development/development-emblem150.png",
      },
      favicon: {
        url: "/assets/development/favicons/favicons.html",
      },
      signin: {
        showBrandName: true,
        hexColor: "#404040",
        url: "/assets/images/background/bg-graph-grey.png",
      },
      colorTheme: {
        index: 28,
      },
      language: "ko",
      region: "ko-kr",
    })

    const agingBrand = _.merge({}, defaultBrand, {
      brandName: "Aging",
      email: "support@aging.com",
      logo: {
        url: "/assets/aging/aging-logo180x35.png",
      },
      emblem: {
        url: "/assets/aging/aging-emblem150.png",
      },
      favicon: {
        url: "/assets/aging/favicons/favicons.html",
      },
      signin: {
        showBrandName: true,
        hexColor: "#213A40",
        url: "/assets/images/background/bg-graph-grey.png",
      },
      colorTheme: {
        index: 29,
      },
      language: "ko",
      region: "ko-kr",
    })

    // 앞으로 브랜드를 만들 경우 의미있는 색상 사용 및 브랜드 로고에 해당 나라의 이니셜 추가
    const ukrtBrand = _.merge({}, defaultBrand, {
      brandName: "UK-RetailTrend",
      email: "support@ukrt.com",
      logo: {
        url: "/assets/ukrt/ukrt-logo180x35.png",
      },
      emblem: {
        url: "/assets/ukrt/ukrt-emblem150.png",
      },
      favicon: {
        url: "/assets/ukrt/favicons/favicons.html",
      },
      signin: {
        showBrandName: true,
        hexColor: "#00247D",
        url: "/assets/images/background/bg-graph-grey.png",
      },
      colorTheme: {
        index: 30,
      },
      language: "en",
      region: "en-gb",
      navMenu: _.merge({}, defaultBrand.navMenu, {
        "app.premiumReport": false,
        "app.standardReport": false,
        "system.monitoring": false,
      }),
    })

    const localgreyBrand = _.merge({}, retailTrendBrand, {
      navMenu: _.merge({}, retailTrendBrand.navMenu, {
        occupancy: false,
        genderAge: true,
        dashboardFace: false,
        "tracking-tree": false,
        "app.datadownload": true,
        "app.premiumReport": false,
        "admin.event": false,
        "admin.s3fileapi": false,
        "system.operation": false,
        "system.data-operation": false,
        "system.recording": false,
        "system.monitoring": false,
        v2: true,
      }),
    })

    const getBrand = () => brand

    const getDefaultBrand = function () {
      let brandName = $rootScope.globalConfig.brand

      if (!brandName) {
        brandName = getUIBrandFromCookie()
      }

      let baseBrand
      if (brandName === "retailtrend") {
        baseBrand = retailTrendBrand
      } else if (brandName === "development") {
        baseBrand = developmentBrand
      } else if (brandName === "aging") {
        baseBrand = agingBrand
      } else if (brandName === "ukrt") {
        baseBrand = ukrtBrand
      } else if ($rootScope.globalConfig.isLocalgrey) {
        baseBrand = localgreyBrand
      } else {
        baseBrand = defaultBrand
      }

      // NOTE: 시스템 테마가 설정된 경우 기본 브랜드에 시스템 테마 설정 병합
      if ($rootScope.systemTheme?.customSettings?.use) {
        const customSettings = $rootScope.systemTheme.customSettings
        const mergedBrand = _.cloneDeep(baseBrand)
        _.merge(mergedBrand, customSettings)
        mergedBrand.isCustom = true
        return mergedBrand
      }

      return baseBrand
    }

    const setBrand = function (req) {
      brand = _.cloneDeep(getDefaultBrand())
      const oldBrandName = brand.brandName
      if (!req && !$rootScope.globalConfig.isLocalgrey) {
        brand.navMenu.dashboardFace = true
      } else if (req != null ? req.customSettings : undefined) {
        const customSettings = req != null ? req.customSettings : undefined
        const customNav = req != null ? req.customNav : undefined
        if (customSettings.use) {
          _.merge(brand, customSettings)
          brand.isCustom = true
        }
        if ((customNav != null ? customNav.active : undefined) === true) {
          _.merge(brand.navMenu, customNav.menu)
        }
      }

      const removeFavicons = () => {
        const head = angular.element("head")
        head.find("link[rel*='apple-touch-icon']").remove()
        head.find("link[rel='manifest']").remove()
        head.find("meta[name='theme-color']").remove()
        head.find("meta[name='msapplication-TileColor']").remove()
        head.find("meta[name='msapplication-config']").remove()
        head.find("link[rel*='icon']").remove()
      }

      if (brand.favicon.url) {
        if (currentFaviconUrl === brand.favicon.url) {
          return Promise.resolve(getBrand())
        }

        $rootScope.title =
          brand.brandName.length === 0 ? getDefaultBrand().brandName : brand.brandName

        const isImageFile = /\.(ico|png|jpg|jpeg|gif|svg)$/i.test(brand.favicon.url)

        if (isImageFile) {
          const head = angular.element("head")
          removeFavicons()
          const existingIcon = head.find("link[rel='icon']:not([sizes])")

          if (existingIcon.length > 0) {
            existingIcon.attr("href", brand.favicon.url)
          } else {
            const href = `${brand.favicon.url}?_=${Date.now()}`
            const faviconLink = `<link rel="icon" href="${href}" />`
            head.append(faviconLink)
          }
          currentFaviconUrl = brand.favicon.url
          return Promise.resolve(getBrand())
        } else {
          if (oldBrandName === brand.brandName && cacheFaviconHtml) {
            if (currentFaviconUrl === brand.favicon.url) {
              return Promise.resolve(getBrand())
            }
            removeFavicons()
            angular.element("head").append(cacheFaviconHtml.data)
            currentFaviconUrl = brand.favicon.url
            return Promise.resolve(getBrand())
          } else {
            return $http({
              method: "GET",
              url: brand.favicon.url,
              transformRequest(data, headersGetter) {
                const headers = headersGetter()
                delete headers["Authorization"]
                return data
              },
              headers: {
                Authorization: undefined,
              },
            }).then(function (res) {
              cacheFaviconHtml = res
              const head = angular.element("head")
              if (currentFaviconUrl && currentFaviconUrl !== brand.favicon.url) {
                removeFavicons()
              }
              head.append(res.data)
              currentFaviconUrl = brand.favicon.url
              return Promise.resolve(getBrand())
            })
          }
        }
      }

      return getBrand()
    }

    const setCustomSettingsbyUrl = (callback) =>
      ApiSrv.getCustomSettingsbyUrl().then((res) =>
        Promise.resolve(setBrand({ customSettings: res })).then((brand) => callback(null, brand))
      )

    brand = _.cloneDeep(getDefaultBrand())

    return {
      getBrand,
      getDefaultBrand,
      setBrand,
      setCustomSettingsbyUrl,
      getUIBrandFromCookie,
    }
  })
